import { on } from '../modules/_fn';

(function () {
	// ---------------------------------------------------------------
	// Swiper

	// breakpoint where swiper will be destroyed
	// and switches to a dual-column layout
	const breakpoint = window.matchMedia('(max-width:63.9375rem)');

	// keep track of swiper instances to destroy later
	let addonSwiper;

	const breakpointChecker = function () {
		// if larger viewport and multi-row layout needed
		if (breakpoint.matches) {
			// clean up old instances and inline styles when available
			if (addonSwiper !== undefined) addonSwiper.destroy(true, true);

			// or/and do nothing
			return;

			// else if a small viewport and single column layout needed
		} else {
			// fire small viewport version of swiper
			return enableSwiper();
		}
	};

	const enableSwiper = function () {
		const swiperTarget = '#addon-carousel';
		// if (typeof Swiper === 'undefined') return false;

		addonSwiper = new Swiper(swiperTarget, {
			loop: false,
			lazy: true,
			slidesPerView: 'auto',
			spaceBetween: 44,
			navigation: {
				nextEl: '.addon_swiper .swiper-button-next',
				prevEl: '.addon_swiper .swiper-button-prev',
			},
		});
	};

	// keep an eye on viewport size changes
	on(breakpoint, 'load', breakpointChecker);
	on(breakpoint, 'change', breakpointChecker);
	// breakpoint.addEventListener('load', breakpointChecker);s
	// breakpoint.addEventListener('change', breakpointChecker);

	// kickstart
	breakpointChecker();
})();
